import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';

export const MessageDate = ({ current, previous }: { current: string; previous?: string }) => {
  const { t } = useTranslation('layout');
  const date = dayjs(current);
  if (!date.isValid() || (previous && date.isSame(dayjs(previous), 'day'))) return null;
  return <div className="consult-message-date"><time dateTime={date.format('YYYY-MM-DD')}>{date.isSame(dayjs(), 'day') ? t('consultPopup.today') : date.format('DD/MM/YYYY')}</time></div>;
};
